export default "/assets/images/payment-methods.png?6bc25cbe0d9391a99468760fc59aae57";